import React, { useState } from 'react';
import { Sidebar } from '../components/dashboard/Sidebar';
import { TopBar } from '../components/dashboard/TopBar';
import { OverviewView } from '../components/dashboard/views/OverviewView';
import { TransactionsView } from '../components/dashboard/views/TransactionsView';
import { BudgetView } from '../components/dashboard/views/BudgetView';
import { InvestmentsView } from '../components/dashboard/views/InvestmentsView';
import { GoalsView } from '../components/dashboard/views/GoalsView';
import { CreditView } from '../components/dashboard/views/CreditView';
import { SettingsView } from '../components/dashboard/views/SettingsView';
import { NotepadView } from '../components/dashboard/views/NotepadView';
import { ChatBubble } from '../components/chat/ChatBubble';
import type { DashboardView } from '../components/dashboard/Sidebar';
const views: Record<DashboardView, React.ReactNode> = {
  overview: <OverviewView data-id="element-974" />,
  transactions: <TransactionsView data-id="element-975" />,
  budget: <BudgetView data-id="element-976" />,
  investments: <InvestmentsView data-id="element-977" />,
  goals: <GoalsView data-id="element-978" />,
  credit: <CreditView data-id="element-979" />,
  notepad: <NotepadView data-id="element-980" />,
  settings: <SettingsView data-id="element-981" />
};
export function DashboardPage() {
  const [activeView, setActiveView] = useState<DashboardView>('overview');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  return <div className="min-h-screen bg-light-bg dark:bg-dark-bg" data-id="element-982">
      <Sidebar activeView={activeView} onViewChange={setActiveView} collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(c => !c)} data-id="element-983" />
      <TopBar activeView={activeView} sidebarCollapsed={sidebarCollapsed} data-id="element-984" />

      <main className="transition-all duration-300 pt-16" style={{
      marginLeft: sidebarCollapsed ? '64px' : '240px'
    }} data-id="element-985">
        {activeView === 'notepad' ? views[activeView] : <div className="p-6 max-w-7xl" data-id="element-986">{views[activeView]}</div>}
      </main>

      <ChatBubble data-id="element-987" />
    </div>;
}